import axios from "axios";
import config from "../../config";
import { ScoringRuleRequest, ScoringRulesModel } from "./types";

const apiUrl = config.api;

const getScoringRules = async (): Promise<ScoringRulesModel> => {
  const response = await axios.get<ScoringRulesModel>(
    `${apiUrl}/scoring/rules`,
  );

  return response.data;
};

const updateScoringRule = async (
  scoringRule: ScoringRuleRequest,
): Promise<ScoringRulesModel> => {
  const response = await axios.put<ScoringRulesModel>(
    `${apiUrl}/scoring/rules/${scoringRule.id}`,
    scoringRule,
  );

  return response.data;
};

export { getScoringRules, updateScoringRule };
